var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body" }, [
    _c("div", { staticClass: "text-size-20" }, [
      _vm._v(
        "\n    ACROSS倉庫から出荷することでSTOCKCREW倉庫へ納品できます。 "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    以下のメニューよりお手続きください。"),
      _c("br"),
      _vm._v("\n    倉庫管理TOP > ACROSS倉庫 > 出荷 > STOCKCREW倉庫へ出荷 "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "btn btn-primary bd-rds-8 text-size-22 pd-t-10 pd-b-10 pd-r-35 pd-l-35 mr-t-10",
          on: {
            click: function($event) {
              _vm.$router.push("/warehouses")
            }
          }
        },
        [
          _vm._v("\n      倉庫管理TOPはコチラ\n      "),
          _c("i", {
            staticClass: "fa fa-arrow-circle-right fa-lg",
            attrs: { "aria-hidden": "true" }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab405058", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab405058","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseSc/DeliveryStatusInquiry.vue
// module id = null
// module chunks = 